import React from 'react';
import PropTypes from 'prop-types';

import MissionText from 'apps/age_gate/components/MissionText';
import AgeRequirementText from 'apps/age_gate/components/AgeRequirementText';

export default class HeaderContainer extends React.Component {
  static propTypes = {
    configurations: PropTypes.object.isRequired,
  };

  missionTextComponent = () => {
    const {
      configurations: { mission },
    } = this.props;

    return mission && <MissionText />;
  };

  ageRequirementTextComponent = () => {
    const {
      configurations: { age_requirement },
    } = this.props;

    return age_requirement && <AgeRequirementText age={age_requirement.age} />;
  };

  render() {
    return (
      <div className="age-gate__header">
        {this.missionTextComponent()}
        {this.ageRequirementTextComponent()}
      </div>
    );
  }
}
